import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Cable } from "lucide-react";

export function BridgeSourceNote() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    api.get("/bridge/status").then((r) => setStatus(r.data)).catch(() => setStatus(false));
  }, []);
  const connected = status && status.connected;
  return (
    <div data-testid="bridge-source-note" className="mb-4 flex items-start gap-2 rounded-lg border border-fundio-border bg-white px-4 py-2.5">
      <Cable className={`mt-0.5 h-4 w-4 shrink-0 ${connected ? "text-status-success" : "text-fundio-faint"}`} />
      <p className="text-xs text-fundio-muted">
        Live-Stammdaten via <span className="font-medium text-fundio-ink">FUNDIO Bridge</span>:{" "}
        <span className={connected ? "text-status-success" : "text-status-warning"}>{connected ? "verbunden" : "nicht verbunden"}</span>.
        {" "}Angezeigt werden lokale Preview-Datensätze (<span className="font-mono text-status-warning">DEMO</span>) – WordPress/Directorist bleibt Master.
      </p>
    </div>
  );
}
